<template>
    <!-- First Modal: Email Confirmation -->
    <div class="modal fade" id="emailModal" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content py-3">
                  <div class="modal-header px-5 border-0">
                      <h5 class="modal-title">
                          <img src="@/assets/Images/Logo/kims-logo.png" width="250">
                      </h5>
                  </div>
                  <div class="modal-body px-lg-5 text-center">
                      <p class="mb-4 text-start">Please confirm your Email address</p>
                      <div class="mb-3 text-start">
                      <input type="email" placeholder="example@gmail.com" v-model="reemail" 
                        :class="['form-control mb-4 custom-placeholder', { 'is-invalid': errors.reemail }]"
                      >
                      <small v-if="errors.reemail" class="text-danger">{{ errors.reemail }}</small>
                      </div>
                      <a class="btn btn-danger w-100" :disabled="hardLock" @click="validationMain" >
                        <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                        <span v-else>Confirm</span>
                      </a>
                  </div>
            </div>
          </div>
    </div>
    <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
      <p>Loading...</p>
    </div>


</template>

<script>
import { ResponseBooking, GetRazorKey, LoadFormNumber, PaymentResponse, PaymentFailed } from "@/api/Post/payment.js";
import { ref } from 'vue';
import axios from 'axios';
import { useAgentStore } from '@/store/agent';
export default {
  name: "VerifyEmailAddressModel",
  data() {
    return {
      errors: {},
      reemail: '',  
      email: '',     
      loading: false,
      entirePageLoading: false,
      agent_id: '',
      hardLock: false,
      rollbackCalled: false,
    };
  },
  
  mounted() {
    const emailModal = new bootstrap.Modal(document.getElementById('emailModal'));
    emailModal.show();
    this.getApplicantEmail();
    // window.addEventListener('beforeunload', () => {
    //   localStorage.removeItem('bookingFormData');
    // });
    // const saved = localStorage.getItem('bookingFormData');
    // this.savedFormData = saved ? JSON.parse(saved) : null;
  },
  methods: {
    getApplicantEmail() {
      const applicantData1 = localStorage.getItem("bookingData");
      const applicantData = localStorage.getItem("NewMember_booking_Data");

      //console.log("Parsed bookingData:", JSON.parse(applicantData || "{}"));
      //console.log("Parsed NewMember_booking_Data:", JSON.parse(applicantData1 || "{}"));

      let parsedData = null;

      if (applicantData) {
        parsedData = JSON.parse(applicantData);
      }

      if ((!parsedData || !parsedData.email) && applicantData1) {
        parsedData = JSON.parse(applicantData1);
      }

      this.email = (parsedData?.email || '').trim().toLowerCase();

      //console.log("Final Email Used:", this.email);

      // if (applicantData) {
      //   const applicant = JSON.parse(applicantData);
      //   this.email = applicant.email || '';  
      // }
    },
    async validationMain() {
        if (this.loading) return;
        this.loading = true;         //  Show loader + disable button

        ///await new Promise(resolve => setTimeout(resolve, 10));
        this.errors.reemail = '';

     
        if (!this.reemail.trim()) {
          this.errors.reemail = "Email is required.";
          this.loading = false;
          return;
        }
        if (!/^\S+@\S+\.\S+$/.test(this.reemail)) {
          this.errors.reemail = "Invalid email format.";
          this.loading = false;
          return;
        }
        if (this.reemail.trim().toLowerCase() !== this.email.trim().toLowerCase()) {
          this.errors.reemail = "Email addresses do not match.";
          this.loading = false;
          return;
        }

        ///console.log("Emails match and are valid:", this.reemail);
        this.loading = true;
        this.errors.reemail = '';
        if (this.hardLock) return;   //  BLOCK every extra click
        this.hardLock = true;        //  LOCK immediately

        try {
          const applicantData = localStorage.getItem("NewMember_booking_Data");
          const savedSlot = localStorage.getItem("selectedSlot");
          ///console.log('applicantData : ', JSON.stringify(applicantData, 2, null));

          const applicant = JSON.parse(applicantData);
          const selectedSlot = JSON.parse(savedSlot);
          

          if (!applicant || !selectedSlot) {
            this.errors.reemail = "Booking data not found.";
            this.loading = false;
            return;
          }

          const agentStore = useAgentStore();
          agentStore.loadAgent();
          ///console.log('AgentTrackId:', agentStore.agentTrackId);
          if(agentStore.agentTrackId) {
            this.agent_id = agentStore.agentTrackId;
          }

          ///console.log('hai applicant : ', applicant);
          const noOfAlwaysChildren = 0;
          ResponseBooking(
            selectedSlot.id,
            applicant.noOfAdult,
            // applicant.noOfChildren,
            noOfAlwaysChildren,
            applicant.fullName,
            applicant.phone,
            applicant.email,
            applicant.booking_id,
            this.agent_id
          ).then(async (responseBookingData) => {
            try {
              const response = responseBookingData.data;

              if (!response.success) {
                this.errors.reemail = response.message || "Something went wrong.";
                return;
              }

              ///console.log("Response Booking Data:", responseBookingData.data);
             /// $('#emailModal').modal('hide');
              const emailModalEl = document.getElementById('emailModal');
              const emailModal = bootstrap.Modal.getInstance(emailModalEl);

              if (emailModal) {
                  emailModal.hide();
              }

              this.$emit('nextStep');

              const bookingDetails = response.details;
              ///console.log("bookingDetails:", bookingDetails);

              const keyRes = await GetRazorKey();
              const razorpayKey = keyRes.data.data.key;
              //console.log('Razorpay Key:', razorpayKey);

              const options = {
                key: razorpayKey,
                //amount: bookingDetails.amount * 100,
                amount: Math.round(bookingDetails.amount * 100),
                currency: bookingDetails.currency,
                name: "KIMSHEALTH",
                description: "Visa Medical Slot Booking",
                order_id: bookingDetails.order_id,
                prefill: {
                  name: applicant.fullName,
                  email: applicant.email,
                  contact: applicant.phone
                },
                notes: {
                  booking_id: bookingDetails.booking_id
                },
                theme: {
                  color: "#FF0000"  // RED THEME
                },

                handler: async (paymentResponse) => {
                  ///console.log("Payment Success:", paymentResponse);
                  try {
                    this.entirePageLoading = true;
                    
                    const entiti_id = this.$route.params.entityId;
                    //console.log("entiti_id:", entiti_id);

                    const response = await PaymentResponse(
                      bookingDetails.booking_id,
                      bookingDetails.amount,
                      1, // Razorpay
                      paymentResponse.razorpay_order_id,
                      paymentResponse.razorpay_payment_id,
                      paymentResponse.razorpay_signature,
                    );

                    //console.log("Payment Response:", response.data);
                    const paymentData = response.data;

                    try {
                      const formResponse = await LoadFormNumber(entiti_id);
                      await new Promise(resolve => setTimeout(resolve, 50));

                      const formData = formResponse.data;
                      localStorage.removeItem('bookingbookingDetails');
                      localStorage.setItem('bookingbookingDetails', JSON.stringify(bookingDetails));

                      localStorage.removeItem('bookingFormData');
                      localStorage.setItem('bookingFormData', JSON.stringify(formData));

                      localStorage.removeItem('bookingPayment');
                      localStorage.setItem('bookingPayment', JSON.stringify(paymentData));

                      localStorage.removeItem('NewMember_bookingFormData');
                      localStorage.setItem('NewMember_bookingFormData', JSON.stringify(formData));
                      // Remove old value
                      localStorage.removeItem('form_response');
                      localStorage.setItem('form_response', JSON.stringify(formData));
                      ///this.$emit('backToSummary', formData);
                      const entityId = this.$route.params.entityId;
                      const applicants = this.$route.query.applicants;
                      ///console.log('applicant applicant :', applicants);
                      this.$router.push({ name: 'ShowForm', params: { entityId }, query: { applicants }, state: { formData } });

                    } catch (formError) {
                      this.$toast.error('Failed to load form!', {
                        position: 'top-right',
                        duration: 3000,
                      });
                      console.error(formError);
                    }

                  } catch (error) {
                    this.$toast.error('Payment failed or verification failed!', {
                      position: 'top-right',
                      duration: 3000,
                    });
                    console.error("Error:", error);
                  } finally {
                    this.entirePageLoading = false;
                  }
                },

                modal: {
                  ondismiss: async () => {
                    console.warn("Razorpay popup closed by user");

                    if (this.rollbackCalled) return;
                    this.rollbackCalled = true;

                    try {
                      await PaymentFailed(
                        bookingDetails.booking_id,
                        applicant.noOfAdult,
                        applicant.noOfChildren
                      );

                      this.$toast.error("Payment cancelled. Booking reverted.", {
                        position: "top-right",
                        duration: 3000
                      });

                    } catch (e) {
                      console.error("Rollback failed:", e);
                    } finally {
                      this.loading = false;
                      this.hardLock = false;
                    }
                  }
                },

              };
              //console.log('options :', options);
              const rzp = new Razorpay(options);
              // Payment failed listener
              // rzp.on('payment.failed', function(response) {
              //   console.error('Payment Failed:', response.error);
              //   this.$toast.error('Payment failed! Please try again.', { position: 'top-right', duration: 3000 });
              // }.bind(this));

              rzp.on('payment.failed', async (response) => {
                  console.error('Payment Failed:', response.error);

                  if (this.rollbackCalled) return; // prevent double call
                  this.rollbackCalled = true;

                  try {
                      await PaymentFailed(
                          bookingDetails.booking_id,
                          applicant.noOfAdult,
                          applicant.noOfChildren
                      );

                      this.$toast.error('Payment failed. Booking reverted.', {
                          position: 'top-right',
                          duration: 3000
                      });

                  } catch (e) {
                      console.error('Rollback API failed:', e);

                      this.$toast.error('Payment failed. Please contact support.', {
                          position: 'top-right',
                          duration: 3000
                      });
                  } finally {
                      this.loading = false;
                      this.hardLock = false;
                  }
              });


              // Open Razorpay popup
              setTimeout(() => rzp.open(), 300);


            } catch (innerError) {
              this.errors.reemail = innerError.response?.data?.message || "Something went wrong during payment.";
              console.error("Inner Booking error:", innerError);
            }
          }).catch((apiError) => {
            const message = apiError?.response?.data?.message || "Booking request failed.";
            this.errors.reemail = message;
            console.error("Booking error:", message);
          });

        } catch (outerError) {
          this.errors.reemail = "Invalid booking/session data.";
          console.error("Outer Booking error:", outerError);
        } finally {
          this.loading = false;
        }

    },
    
  }
};
</script>
